<template>
  <div class="case-item wrap">
    <img
      class="icon"
      src="@/assets/images/home/cases-content/decoration.svg"
      alt="图标"
    >
    <div class="img-wrap">
      <img
        class="case-img"
        :src="image"
        :alt="title"
      >
    </div>
    <div class="case-item__main">
      <div class="title">{{title}}</div>
      <div class="item-name">项目：{{item}}</div>
      <div><span class="item-name">服务方式：{{server}}</span><span class="item-name">调查规模:{{survey}}</span></div>
      <div class="item-name">投入力量：</div>
      <div class="paragraph">{{into}}</div>
      <div class="item-name">主要成效：</div>
      <div class="paragraph">{{effect}}</div>
      <div class="last"><span class="dots">....</span> <span
          class="more"
          @click="handleToCases"
        >了解更多→</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaseItem',
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    item: {
      type: String,
      required: true
    },
    server: {
      type: String,
      required: true
    },
    survey: {
      type: String,
      required: true
    },
    into: {
      type: String,
      required: true
    },
    effect: {
      type: String,
      required: true
    }
  },
  methods: {
    handleToCases () {
      this.$router.push('/cases')
    }
  }
}
</script>

<style lang="less" scoped>
.case-item {
  box-sizing: border-box;
  display: flex;
  position: relative;
  padding: 32px 46px 28px 18px;
  box-shadow: 0px 0px 16px 0px rgba(46, 98, 226, 0.12);
  background-color: #fff;
  transition: 0.2s;
  &:hover {
    box-shadow: 0px 0px 16px 0px rgba(67, 113, 229, 0.18);
  }
  .icon {
    position: absolute;
    top: -30px;
    right: -30px;
    width: 150px;
    height: 103px;
    @media screen and (max-width: 1200px) {
      position: absolute;
      right: 0;
      width: 150px;
      height: 103px;
    }
  }

  .img-wrap {
    margin-right: 40px;
    .case-img {
      width: 540px;
      height: 380px;
    }
  }
  &__main {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    padding-top: 10px;
    font-size: 16px;
    color: #333;
    .title {
      font-size: 20px;
      color: #375ff1;
    }
    .paragraph {
      line-height: 28px;
      color: #6b6b6b;
    }
    .last {
      display: flex;
      justify-content: space-between;
      .more {
        color: #2e62e2;
        cursor: pointer;
        &:hover {
          color: #4371e5;
        }
        &:active {
          color: #1d52d7;
        }
      }
      .dots {
        color: #6b6b6b;
      }
    }
  }
}
</style>
